"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountdownTime = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactCountdown = require("react-countdown");
var _reactI18next = require("react-i18next");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CountdownTime = function CountdownTime(_ref) {
  var days = _ref.days,
    hours = _ref.hours,
    minutes = _ref.minutes,
    seconds = _ref.seconds,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {
      shortFormat: false,
      withoutUnits: false
    } : _ref$options;
  var _useTranslation = (0, _reactI18next.useTranslation)('libCommon'),
    t = _useTranslation.t;
  var isShowDays = !!days && days > 0;
  var isShowHours = isShowDays || !!hours && hours > 0;
  var isShowMinutes = isShowHours || !!minutes && minutes > 0;
  var isShortFormat = options === null || options === void 0 ? void 0 : options.shortFormat;
  if (options !== null && options !== void 0 && options.withoutUnits) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isShowDays && "".concat((0, _reactCountdown.zeroPad)(days), ":"), isShowHours && "".concat((0, _reactCountdown.zeroPad)(hours !== null && hours !== void 0 ? hours : 0), ":"), isShowMinutes && "".concat((0, _reactCountdown.zeroPad)(minutes !== null && minutes !== void 0 ? minutes : 0), ":"), (0, _reactCountdown.zeroPad)(seconds));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isShowDays && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _reactCountdown.zeroPad)(days), " ", t("libCommon:".concat(isShortFormat ? 'shortDay' : 'day')), ' '), isShowHours && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _reactCountdown.zeroPad)(hours !== null && hours !== void 0 ? hours : 0), " ", t("libCommon:".concat(isShortFormat ? 'shortHour' : 'hour')), ' '), isShowMinutes && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _reactCountdown.zeroPad)(minutes !== null && minutes !== void 0 ? minutes : 0), " ", t("libCommon:".concat(isShortFormat ? 'shortMin' : 'min')), ' '), (0, _reactCountdown.zeroPad)(seconds), " ", t("libCommon:".concat(isShortFormat ? 'shortSec' : 'sec')));
};
exports.CountdownTime = CountdownTime;